export default "__VITE_ASSET__DHWRgaDf__"